import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerCountdownTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  CountdownDefinition,
  CountdownProgress,
  CountdownSolution,
  CountdownSubmission,
} from "./types";

registerCountdownTranslations(i18n);

export const countdownModule: PuzzleTypeModule<
  CountdownDefinition,
  CountdownSubmission,
  CountdownProgress,
  CountdownSolution
> = {
  key: "countdown",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
